import api from '@/utils/api';
import { MITRA_DEPOSIT } from '@/utils/api-url';
import {
    // notificationSuccess,
    notificationDanger
} from '@/utils/notification';

const namespaced = true;

const actions = {
    async getDepositBatch(context, data) {
        try {
            const response = await api.apiGetAuth(MITRA_DEPOSIT.BATCH, data);
            return response.data.result;
        } catch (err) {
            notificationDanger(err);
        }
    },
    async createDepositBatch(context, data) {
        try {
            const response = await api.apiPostAuth(MITRA_DEPOSIT.BATCH, data);
            return response.data;
        } catch (err) {
            notificationDanger(err);
        }
    },
    async getDepositBatchDetail(context, data) {
        try {
            const response = await api.apiGetAuth(MITRA_DEPOSIT.BATCH_DETAIL(data.id), data);
            return response.data.result;
        } catch (err) {
            notificationDanger(err);
        }
    },
    async downloadDepositBatch(context, id, data) {
        try {
            const response = await api.apiGetAuth(MITRA_DEPOSIT.BATCH_DOWNLOAD(id), data);
            return response.data.result;
        } catch (err) {
            notificationDanger(err);
        }
    },
    async uploadDepositBatch(context, data) {
        try {
            const response = await api.apiPostAuth(MITRA_DEPOSIT.BATCH_UPLOAD(data.get('id')), data);
            return response.data;
        } catch (err) {
            notificationDanger(err);
        }
    },
    async getMitraDepositDetail(context, id) {
        try {
            const response = await api.apiGetAuth(MITRA_DEPOSIT.DEPOSIT_DATA(id));
            return response.data.result;
        } catch (err) {
            notificationDanger(err);
        }
    },
    async editMitraDepositData(context, data) {
        try {
            const id = data.id;
            delete data.id;
            const response = await api.apiPatchAuth(MITRA_DEPOSIT.DEPOSIT_DATA(id), data);
            return response.data;
        } catch (err) {
            notificationDanger(err);
        }
    },
    async editMitraDepositHistory(context, data) {
        try {
            const id = data.deposit_id;
            delete data.deposit_id;
            const response = await api.apiPatchAuth(MITRA_DEPOSIT.DEPOSIT_HISTORY(id), data);
            return response.data;
        } catch (err) {
            notificationDanger(err);
        }
    },
    async distributeDepositBatch(context, id) {
        try {
            const response = await api.apiPatchAuth(MITRA_DEPOSIT.BATCH_DISTRIBUTE(id));
            return response.data;
        } catch (err) {
            notificationDanger(err);
        }
    },
    async distributeSingleDeposit(context, id) {
        try {
            const response = await api.apiPatchAuth(MITRA_DEPOSIT.DEPOSIT_DISTRIBUTE(id));
            return response.data;
        } catch (err) {
            notificationDanger(err);
        }
    },
    async depositBatchReport(context, id) {
        try {
            const response = await api.apiGetAuth(MITRA_DEPOSIT.DEPOSIT_REPORT(id));
            return response.data.result;
        } catch (err) {
            notificationDanger(err);
        }
    },
};

export default {
    namespaced,
    actions,
};
